import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 21a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3zm12 -16h-8v14h8a1 1 0 0 0 1 -1v-12a1 1 0 0 0 -1 -1","key":"svg-0"}]]

/**
 * IconLayoutSidebarFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItbGF5b3V0LXNpZGViYXIiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTYgMjFhMyAzIDAgMCAxIC0zIC0zdi0xMmEzIDMgMCAwIDEgMyAtM2gxMmEzIDMgMCAwIDEgMyAzdjEyYTMgMyAwIDAgMSAtMyAzem0xMiAtMTZoLTh2MTRoOGExIDEgMCAwIDAgMSAtMXYtMTJhMSAxIDAgMCAwIC0xIC0xIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/layout-sidebar-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLayoutSidebarFilled = createReactComponent('filled', 'layout-sidebar-filled', 'LayoutSidebarFilled', __iconNode);

export default IconLayoutSidebarFilled;